import { useEffect, useState } from "react";
import Cookies from "js-cookie";
import "./PendingPaymentList.css";
import axios from "../../axios.jsx";
import { useNavigate } from "react-router-dom";
axios.defaults.xsrfCookieName = "csrftoken";
axios.defaults.xsrfHeaderName = "X-CSRFTOKEN";

function PendingPaymentList() {
  const [userDetails, setUserDetails] = useState([]);
  setInterval(() => {
    if (!Cookies.get("userInfo")) {
      logout();
    }
  }, 1000);
  useEffect(() => {
    if (Cookies.get("username") != "VerifyOfficer") {
      alert("unauthorized to this page")
      logout();
    }
    document.getElementById("pending-list").style.display = "none";
    async function fetchData() {
      try {
        const resData = await axios.get("/api/get-pending-verification");
        if (resData.status === 200) {
          setUserDetails(resData.data);
        }
      }
      catch (e) {
        if(e.code==="ERR_BAD_REQUEST"){
          logout();
        }
        console.log(e);
      }
    }
    fetchData();
  }, []);
  const handleShowAll = () => {
    if (document.getElementById("pending-list").style.display !== "none") {
      document.getElementById("pending-list").style.display = "none";
      document.getElementById("show-button").innerHTML =
        "Show all Pending applications";
    } else {
      document.getElementById("show-button").innerHTML = "Cancel";
      document.getElementById("pending-list").style.display = "block";
    }
  };

  const toComponentB = (data) => {
    navigate("/verify-details", { state: { mobile: data } });
  };
  const navigate = useNavigate();
  const handleItemClick = async (data) => {
    toComponentB(data);
  };

  const handlePrintFormButton = () => {
    navigate("/scholarlist", { state: { officer: Cookies.get("username") } });
  }

  return (
    <>
      <div className="Auth-form-container">
        <form className="Auth-form">
          <div className="Auth-form-content">
            <h3 className="Auth-form-title">
              Application Verification Pending List
            </h3>
            <div className="d-grid mt-3">
              <button
                id="show-button"
                type="button"
                className="btn btn-secondary"
                onClick={handleShowAll}
              >
                Show all Pending applications
              </button>
            </div>
            <div className="pending-list" id="pending-list">
              {userDetails.map((user, i) => (
                <div
                  key={i}
                  className="pending-item"
                  onClick={(e) => handleItemClick(user.mobile)}
                >
                  <i className="i-font">
                    {user.name}
                    <br />
                    {user.mobile}
                  </i>
                  <span className="icon">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      fill="currentColor"
                      class="bi bi-arrow-right"
                      viewBox="0 0 16 16"
                    >
                      <path
                        fill-rule="evenodd"
                        d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8z"
                      />
                    </svg>
                  </span>
                </div>
              ))}
            </div>
            {Cookies.get("username")==="VerifyOfficer" && <div className="d-grid mt-3">
              <button
                type="button"
                className="btn btn-secondary"
                onClick={handlePrintFormButton}
              >
                Print Scholar Forms
              </button>
            </div>}
            <div className="d-grid mt-3">
              <button
                type="button"
                className="btn btn-secondary"
                onClick={logout}
              >
                Logout
              </button>
            </div>
          </div>
        </form>
      </div>
    </>
  );
}

export default PendingPaymentList;

function logout() {
  window.localStorage.clear();
  Cookies.remove("userInfo");
  Cookies.remove("username");
  window.location.href = "/pvtOfficer-login";
}
